import React from "react";
import SpacingControl from "../SpacingControl";

// MarginBox — thin adapter kept for the existing call-site prop contract
// (10+ block Settings panes construct these props already) delegating all
// rendering to the shared SpacingControl (gordon-0915-law-shared-spacing-
// control-one-row-steppers). The legacy "apply to all sides" checkbox/slider
// path (isApplyMarginOnAllSides/allSideMargin/handleSliderMarginChange/
// handleMarginCheckBox) has no UI trigger left (the checkbox render was
// already commented out) EXCEPT it can still be true for a wheel saved
// before that checkbox was removed — in that case we seed the display from
// allSideMargin so old wheels don't silently show 0 on every side.
function MarginBox({
  margin = { top: 0, bottom: 0, right: 0, left: 0 },
  isApplyMarginOnAllSides,
  allSideMargin,
  fullWidth,
  handleMarginChange = () => {},
  onlyVerticalMargins = false,
  containerStyle = {},
  AccordionContainerStyle = {},
  applyButton = false,
  handleApplyChanges = () => {},
}) {
  const displayValue = isApplyMarginOnAllSides
    ? { top: allSideMargin, bottom: allSideMargin, left: allSideMargin, right: allSideMargin }
    : margin;

  return (
    <SpacingControl
      label="Margin"
      tooltipDescription="The space outside the block."
      value={displayValue}
      onChange={handleMarginChange}
      fullWidth={fullWidth}
      onlyVerticalMargins={onlyVerticalMargins}
      containerStyle={containerStyle}
      AccordionContainerStyle={AccordionContainerStyle}
      applyButton={applyButton}
      onApplyClick={handleApplyChanges}
    />
  );
}

export default MarginBox;
